import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选故事
          </h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto leading-relaxed">
            来自社区成员最真挚的分享，每一篇都是用心写就的情感记录
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/qinggan-gushi"
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-primary-500 text-primary-600 rounded-full text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多故事
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}